import http from '../http'

interface IPage {
  limit: number;
  scroll: string;
}

export default {
  // 金币转账
  transfer(data: object) {
    return http.post('/agent/transfer', data);
  },
  // 获取支付方式和产品列表
  getPayList(country: string) {
    return http.get(`/web/payment/agent/methods?country=${country}`);
  },
  // 获取目标用户信息
  getTargetUserInfo(duid: string) {
    return http.get(`/agent/user/${duid}`);
  },
  // 获取自己的代理信息
  getMyAgentInfo() {
    return http.get('/agent/my');
  },
  // 获取代理金币交易记录
  getAgentTransferRecord({ limit, scroll }: IPage) {
    return http.get('/wallet/agent_gold/record', { limit, scroll });
  }
}
